import UserPaymentTypeHandler from './user-payment-type-handler'

export default UserPaymentTypeHandler
